import { DRXError } from "@/lib/drx-error";

/**
 * Collections where `firestore.rules` deny **all** client writes (`allow write: if false`).
 * Browser code must not call setDoc/updateDoc/deleteDoc/addDoc here — use Cloud Functions / Admin SDK.
 *
 * Keep in sync with `firestore.rules` (search for `allow write: if false`).
 */
export const FIRESTORE_SERVER_ONLY_COLLECTIONS = [
  "subscriptions",
  "payments",
  "paymentLogs",
  "subscriptionLogs",
  "salesEvents",
  "stripeCustomers",
  "webhookEvents",
  "purchaseLogs",
  "adminActionLogs",
  "roleChangeLog",
] as const;

const SERVER_ONLY = new Set<string>(FIRESTORE_SERVER_ONLY_COLLECTIONS);

export function isFirestoreServerOnlyCollection(collectionName: string): boolean {
  return SERVER_ONLY.has(collectionName);
}

/**
 * Throws before hitting Firestore so failures are explicit (dev + support) instead of permission-denied.
 */
export function assertClientMayWriteCollection(
  collectionName: string,
  operation: string
): void {
  if (isFirestoreServerOnlyCollection(collectionName)) {
    throw new DRXError({
      code: "FIRESTORE_CLIENT_WRITE_FORBIDDEN",
      devMessage: `Client ${operation} on "${collectionName}" is blocked by firestore.rules (server-only). Use a Cloud Function or Admin SDK.`,
      userMessage:
        "This action must be completed on the server. If you see this in the app, contact support.",
      level: "warning",
    });
  }
}
